/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { withStyles } from '@material-ui/styles';
import {
    Container, Grid, Tab,
} from '@material-ui/core';
import Media from 'react-media';
import { TabContext, TabList } from '@material-ui/lab';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import plantsForOccasionsStyles from './PlantsForOccasionsStyles';
import DesktopContentView from './Desktop/DesktopContentView';
import MobileContentView from './Mobile/MobileContentView';

import { trackEvent } from '../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const PlantsForOccasions = (props) => {
    const { data, brand } = props;
    const classes = plantsForOccasionsStyles();
    const occasionsTabs = data?.silo_group ? [...data.silo_group] : [];

    const urlRewrite = (url) => {
        const regExp = /^\/c\//gi;
        return regExp.test(url) ? url : `/c${url}`;
    };

    const [activeTab, setActiveTab] = useState({
        image: {
            url: occasionsTabs[0] ? occasionsTabs[0]?.image?.url : '',
        },
        link: {
            title: occasionsTabs[0] ? occasionsTabs[0]?.link?.title : '',
            href: occasionsTabs[0] ? occasionsTabs[0]?.link?.href : '',
        },
        value: 0,
    });
    const [value, setValue] = useState(0);

    const toggleTabs = (e, tabValue) => {
        setValue(tabValue);
        setActiveTab({
            image: {
                url: occasionsTabs[tabValue]?.image?.url,
            },
            link: {
                title: occasionsTabs[tabValue]?.link?.title,
                href: occasionsTabs[tabValue]?.link?.href,
            },
            value: tabValue,
        });
    };

    let lastTabBtnActionInfo = null;
    const dispatch = useDispatch();
    const  handleClick = (label) => dispatch(trackEvent({
        eventCategory: 'Homepage',
        eventAction: 'Click',
        eventLabel: label === 'Shop All' ? `Plants For Occasions - ${label} Button` : `Plants For Occasions - ${label}`,
        eventName: 'feature_interaction',
    }));
    return (
        <div className={`${classes.PlantsForOccassions} plantsForOccassions`}>
            <Container className="container">
                <h2 className="mainTitle" style={{ marginBottom: '3rem', marginTop: '0' }} aria-label={data?.title}>{data?.title}</h2>
                <Grid className="nav-item-holder">

                    <TabContext className="desc-tabs nav-tabs" id="dynamicwidth" value={value}>
                        <TabList aria-label="occasions-tabs" className={`${classes.root} occasions-tabs`} onChange={toggleTabs}>

                            {data?.silo_group && occasionsTabs.map((tab, index) => {
                                const { _metadata, link } = tab;
                                lastTabBtnActionInfo = (index === occasionsTabs?.length - 1) ? link : null;
                                return (
                                    <Tab key={_metadata?.uid} className="normal-tab-btn" id={`plantcareitem${index}`} value={index} label={link?.title} onClick={() => handleClick(link?.title)} />
                                );
                            })}
                            <Link to={urlRewrite(activeTab?.link?.href)}><Tab id="Shop All Tab" onClick={() => handleClick('Shop All')} className="last-item" label="Shop All" /></Link>
                        </TabList>

                        <>
                            <Media query="(min-width: 769px)">
                                {(matches) => (
                                    matches ? (
                                        <>
                                            <DesktopContentView data-view="desktop" activeTab={activeTab} brand={brand} />
                                        </>
                                    ) : (
                                        <>
                                            <MobileContentView data-view="mobile" activeTab={activeTab} brand={brand} action={lastTabBtnActionInfo} />
                                        </>
                                    )
                                )}
                            </Media>
                        </>
                    </TabContext>
                </Grid>
            </Container>
        </div>
    );
};

PlantsForOccasions.propTypes = {
    data: PropTypes.object.isRequired,
    brand: PropTypes.object.isRequired,
};

export default withStyles(plantsForOccasionsStyles)(PlantsForOccasions);
